import { ActionType } from '../Action';
import { ValidationError } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/ValidatorError';
import { SendMessageActionSettingsValidator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/SendMessageActionSettingsValidator';
import { SendRawMessageActionSettingsValidator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/SendRawMessageActionSettingsValidator';
import { SendMessageFromHttpActionSettingsValidator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/SendMessageFromHttpActionSettingsValidator';
import { ProcessHttpActionSettingsValidator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/ProcessHttpActionSettingsValidator';
import { TrackEventActionSettingsValidator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/TrackEventActionSettingsValidator';
import { MergeContactActionSettingsValidator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/MergeContactActionSettingsValidator';
import { RedirectActionSettingsValidator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/RedirectActionSettingsValidator';
import { ManageListActionSettingsValidator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/ManageListActionSettingsValidator';
import { ExecuteScriptActionSettingsValidator } from './ExecuteScriptActionSettingsValidator';
import { ExecuteTemplateActionSettingsValidator } from './ExecuteTemplateActionSettingsValidator';
import { ForwardMessageToDeskActionSettingsValidator } from './ForwardMessageToDeskActionSettingsValidator';
import { SetVariableActionSettingsValidator } from './SetVariableActionSettingsValidator';
import { ProcessCommandActionSettingsValidator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/ProcessCommandActionSettingsValidator';
import { ConditionValidator } from './ConditionValidator';
import { SendSurveyMessageActionSettingsValidator } from './SendSurveyMessageActionSettingValidator';
import { ProcessContentAssistantValidator } from './ProcessContentAssistantValidator';
import { ExecuteScriptV2ActionSettingsValidator } from './ExecuteScriptV2ActionSettingsValidator';
import { ExecuteBlipFunctionActionSettingsValidator } from './ExecuteBlipFunctionActionSettingsValidator';
export class ActionValidator {
    constructor() {
        this.sendMessageActionSettingsValidator = new SendMessageActionSettingsValidator();
        this.sendRawMessageActionSettingsValidator = new SendRawMessageActionSettingsValidator();
        this.sendSurveyMessageActionSettingsValidator = new SendSurveyMessageActionSettingsValidator();
        this.sendMessageFromHttpActionSettingsValidator = new SendMessageFromHttpActionSettingsValidator();
        this.processHttpActionSettingsValidator = new ProcessHttpActionSettingsValidator();
        this.trackEventActionSettingsValidator = new TrackEventActionSettingsValidator();
        this.mergeContactActionSettingsValidator = new MergeContactActionSettingsValidator();
        this.redirectActionSettingsValidator = new RedirectActionSettingsValidator();
        this.manageListActionSettingsValidator = new ManageListActionSettingsValidator();
        this.executeScriptActionSettingsValidator = new ExecuteScriptActionSettingsValidator();
        this.executeScriptV2ActionSettingsValidator = new ExecuteScriptV2ActionSettingsValidator();
        this.executeTemplateActionSettingsValidator = new ExecuteTemplateActionSettingsValidator();
        this.forwardMessageToDeskActionSettingsValidator = new ForwardMessageToDeskActionSettingsValidator();
        this.setVariableActionSettingsValidator = new SetVariableActionSettingsValidator();
        this.processCommandActionSettingsValidator = new ProcessCommandActionSettingsValidator();
        this.processContentAssistantSettingsValidator = new ProcessContentAssistantValidator();
        this.conditionValidator = new ConditionValidator();
        this.executeBlipFunctionActionSettingsValidator = new ExecuteBlipFunctionActionSettingsValidator();
    }
    validate(model) {
        if (!model.type) {
            throw new ValidationError('The action type is required');
        }
        if (!model.settings) {
            throw new ValidationError('The action settings is required');
        }
        switch (model.type) {
            case ActionType.SendMessage:
                this.sendMessageActionSettingsValidator.validate(model.settings);
                break;
            case ActionType.SendRawMessage:
                this.sendRawMessageActionSettingsValidator.validate(model.settings);
                break;
            case ActionType.SendMessageFromHttp:
                this.sendMessageFromHttpActionSettingsValidator.validate(model.settings);
                break;
            case ActionType.ProcessHttp:
                this.processHttpActionSettingsValidator.validate(model.settings);
                break;
            case ActionType.TrackEvent:
                this.trackEventActionSettingsValidator.validate(model.settings);
                break;
            case ActionType.MergeContact:
                this.mergeContactActionSettingsValidator.validate(model.settings);
                break;
            case ActionType.Redirect:
                this.redirectActionSettingsValidator.validate(model.settings);
                break;
            case ActionType.ManageList:
                this.manageListActionSettingsValidator.validate(model.settings);
                break;
            case ActionType.ExecuteScript:
                this.executeScriptActionSettingsValidator.validate(model.settings);
                break;
            case ActionType.ExecuteScriptV2:
                this.executeScriptV2ActionSettingsValidator.validate(model.settings);
                break;
            case ActionType.ExecuteBlipFunction:
                this.executeBlipFunctionActionSettingsValidator.validate(model.settings);
                break;
            case ActionType.ExecuteTemplate:
                this.executeTemplateActionSettingsValidator.validate(model.settings);
                break;
            case ActionType.ForwardMessageToDesk:
                this.forwardMessageToDeskActionSettingsValidator.validate(model.settings);
                break;
            case ActionType.SetVariable:
                this.setVariableActionSettingsValidator.validate(model.settings);
                break;
            case ActionType.ProcessCommand:
                this.processCommandActionSettingsValidator.validate(model.settings);
                break;
            case ActionType.SurveyType:
                this.sendSurveyMessageActionSettingsValidator.validate(model.settings);
                break;
            case ActionType.ProcessContentAssistant:
                this.processContentAssistantSettingsValidator.validate(model.settings);
        }
        if (model.conditions) {
            model.conditions.forEach((condition) => this.conditionValidator.validate(condition));
        }
    }
}
